"use strict";import{html as m}from"@cisco-u/base";import{setCustomTemplateLiteralTag as t}from"./custom-tag.js";t(m);export*from"./icons.js";
//# sourceMappingURL=index.js.map
